import { useState, useEffect } from 'react';
import Keyboard from 'react-simple-keyboard';
import '../machine_css.css';
import 'react-simple-keyboard/build/css/index.css';
import { Modal } from 'react-bootstrap';
import { HighlightOffRounded } from '@material-ui/icons';
import logger from '../../services/LocalServer/logger';

function KeyBoard(props) {
  const [layout, setLayout] = useState('default');
  const {
    input,
    setInput,
    keyboard,
    show,
    handleClose,
    setShow,
    send,
    setReceiptSend,
    error,
    setError,
  } = props;

  const onChange = (input) => {
    setInput(input);
  };

  useEffect(() => {
    const enter = document.querySelector('.hg-button-enter');
    if (enter && enter.onclick == null) {
      enter.onclick = function () {
        setShow(false);
      };
    }
    if (show) logger(2, 'visual keyboard opened.');
    else {
      if (input == '') logger(2, 'input has been clear/no imput, visual keyboard closed.');
      else {
        logger(2, `${input} has been entered, then visual keyboard closed.`);
      }
    }
  }, [show]);

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default';
    setLayout(newLayoutName);
  };

  const onKeyPress = (button) => {
    if (button === '{shift}' || button === '{lock}') handleShift();
    if (send) {
      if (button === '{enter}') {
        if (error === '' && input !== '') {
          setShow(false);
          setReceiptSend(true);
        }
        if (input === '') {
          setError('Email address can not be empty');
        }
      }
    }
  };

  return (
    <Modal
      className="animate__animated animate__zoomInDown"
      data-animate-in="animate__bounceInLeft"
      data-animate-out="animate__bounceInLeft"
      id="keyboard-modal"
      show={show}
      onHide={handleClose}
      size="xl"
      centered
    >
      <Modal.Body>
        <HighlightOffRounded
          style={{ fontSize: '55px', right: '10px', top: '10px', position: 'absolute' }}
          onClick={() => {
            setShow(false);
            setInput('');
          }}
        />
        <div
          className="border border-dark rounded"
          style={
            input.length < 13
              ? {
                  marginLeft: 'auto',
                  height: '200px',
                  fontSize: '7rem',
                  paddingLeft: '20px',
                  paddingTop: '0',
                  margin: '50px 50px 20px 50px',
                }
              : {
                  overflowWrap: 'break-word',
                  marginLeft: 'auto',
                  height: '200px',
                  fontSize: '4rem',
                  paddingLeft: '20px',
                  paddingTop: '0',
                  margin: '50px 50px 20px 50px',
                }
          }
        >
          {input}
        </div>
      </Modal.Body>
      <Keyboard
        id="my-keyboard"
        keyboardRef={(r) => (keyboard.current = r)}
        layoutName={layout}
        onChange={onChange}
        onKeyPress={onKeyPress}
        preventMouseDownDefault={true}
        theme={'hg-theme-default hg-layout-default myTheme'}
        buttonTheme={[
          {
            class: 'keyboard-enter',
            buttons: '{enter}',
          },
        ]}
        display={
          send && {
            '{enter}': 'send',
            '{tab}': 'tab',
            '{bksp}': 'backsapce',
            '{shift}': 'shift',
            '{space}': 'space',
            '{lock}': 'caps',
          }
        }
      />
    </Modal>
  );
}
export default KeyBoard;
